module.exports = __webpack_public_path__ + "templates/cart-redsys-payment.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cart/templates/cart-redsys-payment.html
// module id = 3PM/
// module chunks = 1